import { types } from 'mobx-state-tree';

export const MoneyInfoForPeriod = types.model({
    period: types.string,
    actualSum: types.number,
    planSum: types.number,
    loading: types.optional(types.boolean, false)
}).named('MoneyInfoForPeriod');
